import { useCallback } from "react";
import { useSelector } from "react-redux";
import { trackDashboardCtaClicked } from "analytics";
import { selectExistingOrdersWithoutCancelled } from "store/reducers/order/OrderInformationSlice";
import { Kit } from "types/kit";
import NextMoveCard from ".";
import Translate from "translate/Translate";

const TestingInProgressNextMoveCard = () => {
  const kitOrders = useSelector(selectExistingOrdersWithoutCancelled);
  const ordersForKitsThatAreSubmittedButNotCompleteYet = kitOrders.filter(
    (order: Kit) => order.documentIds?.length === 0
  );
  const hasOrdersInProgress =
    ordersForKitsThatAreSubmittedButNotCompleteYet.length > 0;

  const onActionClick = useCallback(() => {
    trackDashboardCtaClicked({
      workflow: "kit_order",
      ctaLocation: "next_move_card",
      ctaId: "testing_in_progress"
    });
  }, []);

  if (!hasOrdersInProgress) {
    return null;
  }

  return (
    <NextMoveCard
      id="testing-in-progress-next-move"
      title={<Translate text="Testing in progress" />}
      body={
        <Translate text="You will receive a collection kit in the mail; follow the included instructions and return your sample in the prepaid packaging provided. Results will be ready 2-3 weeks after the laboratory receives your sample. If you have trouble with sample collection, simply contact the navigation team." />
      }
      link={{
        onClick: onActionClick,
        overrideClick: true,
        text: "Learn more",
        url: "#"
      }}
    />
  );
};

export default TestingInProgressNextMoveCard;
